import { ApiService, LoggerFactory, Logger } from '@ibe/services';
import { createContext } from 'react';
import { ApiDocument, ApiDocumentSubType } from '@ibe/api';

class DocumentStore {
  private _logger: Logger = LoggerFactory.get('DocumentStore.ts');

  private baseApi: ApiService;

  setApi(api: ApiService): void {
    this.baseApi = api;
  }

  async getDocument(bookingId: string, document: ApiDocument): Promise<Blob> {
    const { precontractualAttachmentId, type, subType, fileName } = document;

    try {
      if (fileName) {
        return this.baseApi.getDocumentUsingSubTypeAndFileName(
          bookingId,
          precontractualAttachmentId,
          type,
          subType || ApiDocumentSubType.UNKNOWN,
          fileName
        );
      } else if (subType) {
        return this.baseApi.getDocumentUsingSubType(
          bookingId,
          precontractualAttachmentId,
          type,
          subType
        );
      }

      return await this.baseApi.getDocument(bookingId, precontractualAttachmentId, type);
    } catch (e) {
      this._logger.warn(e);
      return Promise.reject();
    }
  }
}

export default DocumentStore;

const documentStore = new DocumentStore();

export const documentStoreContext = createContext(documentStore);
